import GradeForm from "../../components/Forms/GradeForm";
import MainGoal from "../../components/Forms/MainGoal";
import PrimaryCategory from "../../components/Forms/PrimaryCategory";
import SubCategoryForm from "../../components/Forms/SubCategoryForm";
import BasicCard from "../BasicCard";

import Dummylayout from "../Dummylayout";

function SubCategorymain() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
                <SubCategoryForm/>         
           </BasicCard>
            </div>
        </>
    )
}
export default SubCategorymain;